<template>
  <v-alert
    class="animate__animated animate__bounce"
    width="100%"
    text
    type="error"
    elevation="0"
    v-model="resource.display"
  >
    <h6 class="alertaText">{{ resource.message }}</h6>
    <v-btn
      class="btn-close"
      small
      color="red"
      text
      @click="resource.display = false"
    >
      FECHAR
    </v-btn>
  </v-alert>
</template>

<script>
import "animate.css";
export default {
  data() {
    return {
      teste: 8000,
    };
  },

  props: {
    resource: {
      type: [Array, Object, String],
    },
  },
};
</script>

<style>
.v-alert {
  margin-bottom: 10px;
}

.v-alert__content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.alertaText {
  font-size: 14px;
  font-weight: 500;
}
</style>
